import Navbar from '../components/Home/Navbar'
import drgagriel from '../assets/drgabriel2.jpeg'
import { notes } from '../utilities/story'
import Footer from '../components/Footer'
import { useState } from 'react'
import ScrollUpButton from '../components/Widgets/ScrollUpButton'
import QuoteIcon from '../components/Icons/QuoteIcon'
import { headlinks } from '../utilities/links'

const Story = () => {
	const [showAll, setShowAll] = useState(false);
	return (
		<div>
			<Navbar links={headlinks} />
			<section id="top" className="h-[50vh] bg-cover relative bg-center bg-[url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8dHV0b3J8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=1400&q=60')]">
				<div className='inset-0 absolute bg-[#161c2dbf] opacity-90'></div>
				<div className='flex h-full flex-col relative'>
					<div className='my-auto pt-20 app-x'>
						<h3 className='font-serif font-extrabold text-white text-5xl'>Dr. Gabriel’s Story! </h3>
						<p className='text-secondary font-serif my-4 text-2xl selection:text-slate-500 font-bold'>Why SMARTA?</p>
					</div>
				</div>
			</section>
			<section className='xl:px-24 dark:bg-slate-900 px-10 flex lg:flex-row lg:space-x-10 lg:py-20 py-10 flex-col'>
				<img src={drgagriel} alt="Dr Gabriel" className='rounded-full lg:sticky lg:top-28 w-60 h-60 lg:w-96 lg:h-96 object-cover' />
				<div>
					<QuoteIcon className="my-9 h-[60px]" />
					<div className={`relative ${!showAll && 'overflow-y-hidden h-[26rem] '}`}>
						{notes.map((each, i) => (
							<p key={i} className='py-3 text-justify text-slate-700 dark:text-slate-200'>{each}</p>
						))}
						<div className={`${!showAll && 'absolute bottom-0 h-10 '} bg-gradient-to-t from-white dark:from-slate-900 via-white dark:via-slate-900 flex items-end w-full`}>
							<button className='text-primary text-[.8rem] rounded focused' onClick={() => setShowAll(!showAll)}>See {showAll ? 'Less' : 'more'}</button>
						</div>
					</div>
				</div>
			</section>
			<Footer />
			<ScrollUpButton />
		</div>
	)
}

export default Story